export const BUTTON_LABELS = {
  createMore: 'Create more',
  createFullscreen: 'Open issue creation in fullscreen',
  copyUrl: 'Copy permalink',
  create: 'Create',
  cancel: 'Cancel',
}
